export default __webpack_public_path__ + "static/media/Swedbank.fc889dbf.svg";